export default {
  decision: "ACCEPTED",
  decisionParameters: {
    fee: 0.1920,
    firstInstallmentDate: Date.now().toLocaleString(),
    installmentAmount: 112,
    loanPeriod: 12
  }
}
